export default "__VITE_ASSET__ec1f1d90__"